export default "__VITE_ASSET__KeAt_RwA__"